import { Accordion, AccordionBody, AccordionHeader } from "@material-tailwind/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SuccessAnimation from "../../animation/SuccessAnimation";
import { formatPrice } from "../../services/formatPrice";
import { PaymentProductRow } from "../PaymentProductRow";
import NotFound from "./NotFound";
import { DeleteOrder, GetAllOrderByUser } from "../../services/ApiServices/OrderService";
import { DeleteOrderProduct } from "../../services/ApiServices/OrderProductService";
import { DeletePayment } from "../../services/ApiServices/PaymentService";
import { DeleteUserInfo } from "../../services/ApiServices/UserService";

function Order({ id, setLoading }: any) {
    const [orders, setOrders] = useState<any>([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [open, setOpen] = useState(1);
    const navigate = useNavigate();

    const handleOpen = (value: number) => setOpen(open === value ? 0 : value);

    const fetchOrders = async () => {
        let userInfos = null;
        setLoading(true);
        try {
            userInfos = await GetAllOrderByUser(id);
            setOrders(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    }

    const handleCancelOrder = async (orderId: any) => {
        setLoading(true);
        try {
            await Promise.all(
                orders.find((order:any) => order.id === orderId).orderProducts.map((product: any) =>
                    DeleteOrderProduct(product.id)
                )
            );
            await DeleteOrder(orderId);
            await DeleteUserInfo(orders.find((order:any) => order.id === orderId).userInfo.id)
            await Promise.all(
                orders.find((order:any) => order.id === orderId).payments.map((payment: any) =>
                    DeletePayment(payment.id)
                )
            );
            

            fetchOrders();
            alert("Order has been successfully canceled.");
        } catch (error) {
            console.error("Failed to cancel order:", error);
            setErrorMessage("Failed to cancel the order. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchOrders();
    }, []);

    if (!id) {
        return <NotFound />;
    }

    return (
        <div className="about-container w-full my-5" style={{ padding: "1rem", borderRadius: "8px" }}>
            <div className="text-center mb-8">
                <h2 className="text-4xl font-semibold text-[#395F18]">Đơn hàng của bạn</h2>
                <div className="underline"></div>
                <div className="text-red-500">{errorMessage}</div>
                {orders.length === 0 ? (
                    <div className="text-center my-5">
                        <p>Hiện tại bạn chưa có đơn hàng nào! Hãy mua sắm ngay!</p>
                        <div className="mt-3 flex justify-center">
                            <Link to="/products">
                                <button className="border-2 rounded-bl-none rounded-br-none border-b-black flex gap-3 items-center px-4 py-2 bg-white text-black hover:bg-gray-100 transition duration-300 ease-in-out">
                                    Mua sắm
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
                                </button>
                            </Link>
                        </div>
                    </div>
                ) : (
                    orders.map((order: any, index: number) => (
                        <Accordion placeholder={""} key={index} open={open === index + 1} className="mb-2 rounded-lg border border-blue-gray-100 p-5">
                            <div className="flex justify-between">
                                <div className="text-2xl font-semibold">Đơn hàng</div>
                                <div className="text-lg font-semibold">{moment(order.orderDate).format("DD/MM/YYYY")}</div>
                            </div>
                            <AccordionHeader placeholder={""} onClick={() => navigate(`/order-detail/${order.id}`)} className="border-b-0 transition-colors">
                                <div className="w-full">
                                    {order.orderProducts.length > 0 && order.orderProducts.map((product: any) => (
                                        <PaymentProductRow product={product} key={product.id} />
                                    ))}
                                </div>
                            </AccordionHeader>
                            
                            <div style={{ alignItems: "center" }} className="flex justify-start gap-5">
                                <div className="text-xl font-semibold">Tổng tiền:</div>
                                <div className="text-red-500 text-lg">{formatPrice(order.totalPrice)}</div>
                            </div>
                            <div style={{ alignItems: "center" }} className="flex justify-start gap-5">
                                <div className="text-xl font-semibold">Trạng thái:</div>
                                <div>{order.status}</div>
                            </div>
                            <div style={{ alignItems: "center" }} className="flex justify-start gap-5">
                                <div className="text-xl font-semibold">Phương thức thanh toán:</div>
                                <div>{order.payments[0].description}</div>
                            </div>
                            <div className="flex justify-end mt-5">
                                <button 
                                    onClick={() => handleCancelOrder(order.id)} 
                                    disabled={order.status === "Đang vận chuyển"}
                                    className={`px-4 py-2 rounded-lg transition duration-300 ease-in-out ${order.status === "Đang vận chuyển" ? "bg-gray-400 cursor-not-allowed" : "bg-red-500 hover:bg-red-600 text-white"}`}
                                >
                                    Huỷ đơn hàng
                                </button>
                            </div>
                        </Accordion>
                    ))
                )}
            </div>
        </div>
    );
}

export default Order;
